/**
 * @desc 导出调拨单明细
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.allocationMaster.exportAllocationDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/allocationMaster/exportAllocationDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
